import type React from "react";
import {
  Breadcrumb as ShadcnBreadcrumb,
  BreadcrumbList as ShadcnBreadcrumbList,
  BreadcrumbItem as ShadcnBreadcrumbItem,
  BreadcrumbLink as ShadcnBreadcrumbLink,
  BreadcrumbPage as ShadcnBreadcrumbPage,
  BreadcrumbSeparator as ShadcnBreadcrumbSeparator,
  BreadcrumbEllipsis as ShadcnBreadcrumbEllipsis,
} from "src/shadcn/components/breadcrumb";

const Breadcrumb = (props: React.ComponentProps<typeof ShadcnBreadcrumb>) => (
  <ShadcnBreadcrumb {...props} />
);

const BreadcrumbList = (
  props: React.ComponentProps<typeof ShadcnBreadcrumbList>
) => <ShadcnBreadcrumbList {...props} />;

const BreadcrumbItem = (
  props: React.ComponentProps<typeof ShadcnBreadcrumbItem>
) => <ShadcnBreadcrumbItem {...props} />;

const BreadcrumbLink = (
  props: React.ComponentProps<typeof ShadcnBreadcrumbLink>
) => <ShadcnBreadcrumbLink {...props} />;

const BreadcrumbPage = (
  props: React.ComponentProps<typeof ShadcnBreadcrumbPage>
) => <ShadcnBreadcrumbPage {...props} />;

const BreadcrumbSeparator = (
  props: React.ComponentProps<typeof ShadcnBreadcrumbSeparator>
) => <ShadcnBreadcrumbSeparator {...props} />;

const BreadcrumbEllipsis = (
  props: React.ComponentProps<typeof ShadcnBreadcrumbEllipsis>
) => <ShadcnBreadcrumbEllipsis {...props} />;

export {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator,
  BreadcrumbEllipsis,
};
